const Title = ({text}) => {
  const base = 'text-subheadingMobile md:text-displayDesktop text-olive font-ttDrugsTrial uppercase'

  return <span className={base}>{text}</span>
}

export default Title
